var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    d: "M.3 0h53.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd1021",
    d: "M.3 20 53.6 0v40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.3 20 53.6 2.1V38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.8 22.5c.5 0 .5.5.5.5h1.5q.2-.6.7-.2l.7.4c.2-.8 1.3-.6 1.3-.6.4-1.1.5-1.1.2-1.2l-.4-.4q-.4-.6-.4-1c0-.3-.4 0-.4 0h-.8v.2l-.4-.1h-.6l-.9.3-1 .7-.6.3c-.2.4-1.1 1-1.1 1q-.3.2-.9 0v-.6q.2-.1.2-.8 0-.5.9-1.1l1.2-1.5.1.3.4-.5.3-.3q-.1-.1-1 .4-.5.3-.6.2-.4-.2-.3-.3c-.2-1 .6-1.6.6-1.6-1.1-.2-.3-1.7 1-2.3s1.4-.8 1.4-.8l.2.2.9-.5 1.2-.6v.3c2.3-.8 4.4-2.5 4.4-2.5v.3l1.7-1-.4.6v.2l1.3-.8c.3.3 0 .8 0 .8l.2-.1c.1.5-.5 1-.5 1l.3-.1c-.1.6-1.2 1.2-1.2 1.2q.1.3-.1.4-.4.2-.3.4l.5-.3c.1.3-.5.7-.5.7.4 0 1.6-.5 1.6-.5q-.1.8-1 1l-.6.3.9-.1c-.3.5-1 .8-1 .8q.2.2.8-.2l1.1-.5q.8-.2.8 0h.7q1 .1.8.3l.3.2q.3.3.2.8l-.1.2v.2c0 .1-.2.6-1.4.6h-1.9c-.4.3-.2-.1-.8.4q-.8.5-.8.3l-1 1q-.5.1 0 .2t.7 0c-.3.2 0 .3 0 .3l.5-.1c.2.3-.3.8-.3.8h.5q-.1.4-.6.5-.3.1-.1.3v.3c-.4-.3-.4 0-.4 0v.7h-.4q-.2.6-.4.7L47 22q-.3.5-.5.5v.8h-.3l2.9.1.2.3q-.1.4-.3.4l-3-.1-.2.1-.1.3c0 .4-.7 0-.7 0l-.3.3q-.2-.6-.5-.2c-.2.4.4.3.4.3l3.8-.5q.3 0 .5.3c0 .2-.5.3-.5.3l-3.6.4q-.3.3-.4.2 0 .3-.3.4h-.5c-.4.3-.6 0-.6 0q-.4.3-.7 0-.3-.1-.2-.3l-2.3.2-.2.1-.2.4q.2 0 .3.4c0 .4-.4.4-.2.6q.3.2 1-.1l.9-.2 1 .2h.4l.1-.3v.2h.4l-.2.1c-.3.2.1.1.1.1h1.3l1.2.3v-.3l.4.2v-.3c.8.5-.2.7-.4.8q-.4.1-.3.2l.6-.1.5-.1h.6l-.4.2v.3c-.3-.4-.6 0-.6 0l.5.1.5.3h.4q.3.3.2.4l-.3-.3q-.1.4-.3.3c.3-.3-.3-.4-.6-.4l-.6.2c.6.5 1 .3 1 .3 0 .3-.5.2-.5.2q.3.2.2.3t-.8-.4q-.7-.3-.8-.2c.4.5-.1.8-.1.8-.3 0 0 .3 0 .3q-.3-.1-.3-.3l-.3.2.4-.4q0-.6-1.4-.4-1.4 0-1.3-.2h-.1l.2.4v.2l-.2-.3v.5q-.3-.1-.1-.4l-.3-.3q-.3-.1-.4 0A1 1 0 0 1 40 29h-.3c-.7.3-1.4-.4-1.4-.4q-.7 0-1-.4l-.4-.4q-.4-.4-.2-.8l.1-.2c-.3-.5.5-.6.5-.7q0-.3.4-.3.2 0 .3-.2h.4s.4-.3.8-.1h.6l2.4-.3q0-.3.8-.6t1-.5h-.4l-.3-.2-.9.4c-.7.4-.7-.4-.7-.4h-1.5l-.2.5h-.5q-.4-.5-.3-.7a5 5 0 0 0-2.6.6c-1.8-1-3.2-1.1-3.2-1.1q1.8-.1 3.4-.9 1 .6 2.4.8.1-.7.3-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc221",
    d: "M37.2 26.2q-.6.4-.3.5l-.1.3-.1.2q.1.5.4.7l.3.3q.4.5.7.4t0-.1l-.2-.3.5.4q.8.6 1 .4l.3-.1h-.2c-.7-.1-1-.6-1-.6q.6.5 1.3.5h.2-.2q-.2 0 0 .1h.1l.4.3c.3.2 1 0 1 0q-.7-.2-.6-.3-.9-.1-.9-.3l-.4-.3-.4-.5q.1.3.5.4l.3.1h-.2q-.2 0 0 0l.3.2c.7.1.4-.2.4-.2h.6c0 .2.5 0 .5 0-.6.3-.2.3-.2.3h.7l.2.1h.3l.8.2h.4l-.4.1q-.5.2-1.2 0h-.6l.3.3.3-.1.4.2h.5v-.1h.2l.2.1v-.1c.2-.2.8-.2.8-.2q.6.3.4.4l.2.2v-.2q.3.1.3.3c.2-.2-.2-.5-.2-.5h.6q.3 0 .5.2l.5.2-.2-.2h.2l-.7-.5.3-.1-.4-.1h1.1c-.2-.3-.9-.2-1.1-.2h-.3l.2-.1.6-.1q.4-.2.5-.1-.2-.3-.7 0l-.5.1q.6-.1.5-.2h-.8l.5-.2-.5-.2q-.2.4-1 .1l-.7-.2a1 1 0 0 1 1.2 0q.5.1.4 0c.8.4 1.1.1 1.3 0s-.1-.3-.1-.3q0 .4-.6.3-.4 0-.9-.4h-2l-1.1-.2-1.3.2q-.6.4-.8.1-.2 0 0-.3v-.5l-.2-.3q.3-.3.2-.4l.2-.1v-.1l-.5-.1c-.4-.2-.8.1-.8.1H38l-.2.1-.4.2v.4q-.2 0-.1.2v.3-.3l-.2.2v-.3l.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m37.7 28.2-.2-.4v-.4.4l-.2-.3v-.3H37q-.3 0 .1.4l.2.3zm1-.7.2-.3v-.6c.2-.2 0-.3.3-.6l.2-.1-.5.2c-.1 0-.8.3-.6.6v.3q-.2 0-.2-.6l.3-.2c.1-.2 0 0 .3-.2l.4-.3-.2.1-.5.2q-.3.2-.4.7-.1.1-.4-.4s-.6.8.7 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc221",
    d: "M44.6 25c.5-.2 3.4-.6 3.7-.6l.5.1q-.2.4-.4.3l-3.5.4h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3719",
    d: "M37.6 26.5s-.4.8 1 1l.2-.3q.2-.1 0-.5c0-.2.1 0 .2-.3v-.3l-.6.4c-.2.2.2.3 0 .6l-.3-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m39 27.4.8.3q.6 0 .8-.3v.3s.4-.4 1 0l.6.1-.9.3c-.6.3-2.3.1-2.3-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3719",
    d: "m38.4 26 .4-.1zm-1.2 1.5s-.3-.2 0-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M43.8 29q0-.2.6-.3l1 .2q-.2.2-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3719",
    d: "M39.2 27.6s.7.5 1.3 0l.1.2s.5-.5 1.3 0l-.5.1c-.5.3-1.8.4-2.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m41.9 28 1.2.1h.5q-.3.2.7.1c.8 0 0 .1.6.2 0 0-1.4.7-3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3719",
    d: "M43.6 27.6h.8q.3.3.5.3h-.6zm.4 1.2q.1-.2.8 0l.3.1H44m-1.9-.7h1.4s-.6.3.8.2h.2l.1.1s-1 .5-2.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m37.9 27.4.2.2.3.3.3.2s-.7.2-1-.2c0 0-.2-.2.2-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3719",
    d: "m43.1 29-.6-.2-.6-.1q-.4-.2-.7 0-.3 0 0-.3h-.8q.2.1-.5.2a1 1 0 0 0 1 .2l.2.3q.3 0 .5.2l-.4-.4h.5q.7.3 1.4 0m.2.3h.3q.5 0 .8.2.1-.1-.6-.3zM38 27.5s-.3.2 0 .4q.3.3.6.2l-.1-.2-.3-.2zm-.3-1s-.4.8 1.1 1v-.3q.2-.1.1-.5c-.1-.2.1 0 .2-.3v-.3l-.6.4c-.2.2.2.3 0 .6l-.3-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m41.4 28.3 1.1.2q1.1.3 1.2.2s-.4.3-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc221",
    d: "M46.3 28.1h.5zm-.5-.4.2-.1-.2-.2zm-6-2 .2-.1 2.6-.4h.1q.1.2-.6.3l-2.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc221",
    d: "m42.2 25.6.3.4q.5 0 .6-.2v-.5h-.3l-.2.2v.2-.1zm1.4-.3q.3.1 0 .6-.5.2-.5 0v-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc221",
    d: "M43.8 25.3v.5q.4 0 .5-.3h-.1v-.1q.2 0-.1-.3H44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc221",
    d: "m44.1 25 .3.3v.1l.3-.2-.3-.3zm-1.3.3-.2-.2h.3q.2.1.1.2zm.5 0h.3q0-.2-.4-.2zm.4 0 .2-.2-.2-.1h-.2zm0-.4.3.1.2-.1h-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3719",
    d: "M36.7 24.2s.5-.5.9-.4h.5l1-.1-1.3-.3-1 .4s-.7-.4-1.5-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc221",
    d: "M43 25.1h.1q.1.1 0 .2zm-.7 0v.1l.3-.1h.5l.2-.1h.2l.3-.1q.2 0 0-.2h.3l.2-.3q.2-.3 0-.2H44q-.2.2-1 .4-.4.1-.7.5m-8.5-2 1.2.4-.4-.2s1.1 0 2.2.4c0 0 .6-.4 2.3-.3v-.3s-1.2 0-2.3-.7q0 .2-3 .8m5.4.5c0-1 .3-1 .3-1h.4q-.2 0-.2 1l-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3719",
    d: "m39.5 24.3-.2-.4h.4l.2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc221",
    d: "M39.9 23.8v-.4q0-.7.1-.4h.2s-.2-.6-.3-.2q-.2.3-.1.8v.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3719",
    d: "M42 23.8s.4 0-.2.2c0 0 0 .7.7.2l.7-.3v-.2l-.2-.1h-.2q0 .2.1.1s.3-.1.1 0c-.2.3-.3 0-.4 0zm-1.8 0H40q0 .1-.1 0v.1s.1.8.3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc221",
    d: "M40 23v.8h1.7v-.7h-.2v.6-.6h-.2v.6-.6H41v.6-.6h-.3v.6-.6h-.2v.6-.6h-.3v.6-.6zm1.8 1 .1-1.2q.2-.2.5 0l.7.4.1.2q0 .3-.2 0l-.2-.1q-.2 0 .1.1.2.1 0 .2-.6 0-1 .3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M42.4 23.3v-.2q.2.1.3.4zm-.2.8q-.1 0 0 0l.3-.1zm.2-.3h.2-.1q-.2 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc221",
    d: "M43.3 23.6q-.1.1.4.4v-.3h-.1v-.1h.1v-.2q-.1 0 0-.1V23q.2 0 0-.1h.1l.2-.2s.4-.2 0-.2l-.6.3zm1 .2q.1.2-.1.2 0 .2-.2 0l-.2-.1zm-.5 0h.5v-.1h-.4m0-.3h.4v-.1zm0-.2h.5-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3719",
    d: "m48.8 23.8.1.2h-3.7v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc221",
    d: "M43.9 23.2h.4-.1l.1-.1h.1q.1-.1 0-.1-.2 0 0 0h.2v-.1q-.1 0 0 0v-.1h.8v-.2h.1v-.2q.1-.2 0-.4l-.3.3q-.2.4-.5.4-.5-.2-.5 0v.1H44v.3zm.3.9h.3q0-.2-.3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc221",
    d: "M44.6 23q0-.2.6-.1l.3.2v.1h.1v.1h-.4V23l-.2.1v.1q-.4 0-.1.1l.1.2q.2.2 0 .3.2 0 .1.1l-.4.1q.2 0-.1-.1l-.1-.2v-.1q-.1 0 0-.1h.2q-.3 0-.3-.2h.2l-.1-.2h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M44.9 23q.1 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc221",
    d: "M45.2 23.4q-.2 0 0 .1v.2l3.6.1.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3719",
    d: "m48.9 23.8.1-.3.2.1q0 .5-.2.4v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b3c20",
    d: "m44.7 24.6.3-.3s.7.5.6 0v-.2l.3-.1h-.7q-.2.2-.5.1h-.2v.2zm1.4-1.3h-.3l-.4-.4v-.1l.3-.3q.2.2.5.2v-.2h.1l.1.3v.4s-.4-.2-.2.1m-1.5-.7h.4q.2-.3.1-.5l.1-.4.1-.4q.1-.4.4-.5c0-.1.3-.2 0-.3-.4 0-1.2-.3-1.4-.6q-.2-.2-.2 0v.6l.6.7q.4.1.3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3719",
    d: "M45.6 21.8s0 .6.5.8v-.5l.3.1-.2-.2q-.2-.3 0-.6v-.2q-.1-.1 0-.1.4 0 .1-.2-.1-.1 0-.2.5 0 .3-.2-.2 0 0-.2.5 0 .2-.1-.3 0-.1-.1t-.2-.2c-.2 0-.6 0-.3-.2s-.5 0-.1-.2c.3-.2-.1-.1-.2-.1v-.1q0-.2-.2 0V19h-.2l-.4.1h-.4s0-.3-.2 0-.1-.3-.3-.1h-.3l-.4.1q-.2.1 0-.2s.1-.4 0-.1q0 .2-.4-.2s-.3.4-.4.2q0-.2-.2 0v-.1q.1-.3-.5 0c-.4.4.1.1-.2.3s-1.1.5-.4.5c.7-.2-.3.2 0 .3s0 .3 1 0 .8 0 1.3-.2-.1 0 .5 0 .1 0 .3.2q.2.3 1.1.5h.5l-.3.5q-.2 0-.3.5c0 .3-.4.4-.2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3719",
    d: "M46.4 22.5v-.2s.3-.3 0-.4q-.5-.3 0-.5v-.1q-.1-.2 0-.2.4 0 .1-.1l-.1-.2s.6-.2.4-.3q-.2-.1.1-.2l.3-.2h-.3v-.2l-.4-.2h-.1l-.1-.2.1-.2H46l.1-.3h-.3l-.4.2h-.1q.1-.2-.5 0l.2-.3q.1-.2-.6.2l-.1-.2-.3.2q0-.2-.2 0v-.2l-.1-.3q0 .2-.4.3l-.2-.3q-.1-.2-.2 0l-.1.3-.2-.2v.1l-.1-.3-.8.6h-1l.3-.3-.1-.2h.2v-.3q.4.1.3-.1v-.3l.4.1h.3l.3-.2q.3.1.1-.5c0-.6.4.3.1-.6l-.3-.4q0 .1-.2 0c-.2-.2-.7-.2-.5-.4q.3-.2.2-.4 0 .2-.6 0l-.6.1.2-.3-.3.1q-.3 0 .2-.2c.3-.3 1-.7.9-1.1h.5q.7-.1.9-.4l.5-.4q.2 0 0 0 0 .4-.8.9l-1 .5c0 .1-.5.4-.2.3h.6q-.5 0-.3-.2l.7-.5c.3-.1.7-.5.7 0 0 .3-.7.7-.9.8v.1l-.2.2v.4h.1q0 .2.2.2h.2q0 .2 0 0t0-.1h-.2q0-.2-.1-.1-.1 0 0-.2l.3-.2.2-.2-.4.2v-.1q.1-.3.4-.4.4 0 .4.3-.5.3-.4.5h.3v.4l-.2.2s-.2-.3-.2 0v.3l.3.1s-.4.2-.2.2q.4 0 .6-.2l-.5-.2s.4-.1.3-.5c0 0 .4 0 .2.3q-.4.1-.1.2h.2v.4l.1-.2c-.1 0 .2 0 0-.1l-.2-.1s1.7-1 .8-.7q0-.2.4-.4.4 0 .2.4-.2.3-.6.4s.5.2 0 .6l-.2.1.5-.2.2-.3 1-.8q.1-.3.5-.6l.4-.3.2-.3 1-.6.9-.6q.4-.6.7-.5t-.3.4c-.2.3-1 .8-1 1l-1 .5q-.2 0-.3.2l-.6.5-.3.4-.2.3-1 .7s.4.1.2.4l-.3.2s.6 0 .2.4h.1q.2-.4 0-.4l.7-.2q.6 0 0-.1.1-.2.5-.1.2 0-.1.3-.4 0-.7.3l.6-.1q.3-.2.3 0v.1l-.2.2-.2.2q-.3 0-.2.2v.3l-.3-.2q0-.2-.4 0-.4.1-.3-.1h-.4q-.2-.2.1-.3s.5-.3.2-.2l-.6-.1.2-.2q.1.1.2 0l.2-.2h-.3q0-.2-.4 0h.2l-.3.4q-.2.2 0 .1c.3 0 .7 0 .4.2q-.2.4-.5.3l.1-.1v-.1l-.3-.1v-.5q-.1 0 0 0l-.2-.2v.3q.1 0 0 .2v.1q.2 0 .1.2v.1q.2 0 .2.2h.8q0 .4.1.1h.8q.2.3 0 .4h.2q.3-.2.8 0h1q.5.3.6.2l-.6.2-.6.1.3.3h.3v.2q.3 0 .2.3v.2l-.2.4v.1l-.1.4q-.2 0-.4.6l.3-.5.2-.3.1-.2v-.3l.2-.2v-.3c.2-.1-.3-.3-.1-.4 0 0 .3-.1-.5-.1l.9-.3-.2.3h.1l-.1.2.4.3-.3.2.1.2-.2.2-.1.1-.1.2v.4h-.2v.3H47l-.3.5.4-.2.2-.4q.3-.3.2-.4v-.4l.6-.2-.3-.3.4-.1-.5-.4.3-.3h-.2l.3-.3.1.3q.2-.2.6-.2.2 0-.4.8h.5l-.5.4c-.4.2 0 .4-.4.3q-.4 0-.2.4v.5s-.4-.2-.4.2q0 .4-.2.4L47 22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b3c20",
    d: "M46 18.4h.3q.4.2.1-.1-.2-.1.2 0 .3.2.4 0v-.2h.2v.2s0 .3.2 0l.3-.4.1.1h.3v-.5s.2.3.4 0l.4-.1.7-.4q0-.2.4-.1.5-.2.6-.6v-.2h-.3v.2l-.4.1-.4.2q.2 0 0 .3H49l-.4.3-.3.2-.2-.1-.3.3-.2-.2q.1.1-.4.5l-.1-.2s-.4.4-.6.4q-.1 0 0-.1v-.3H46l-.1.2h-.3v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3719",
    d: "m46.8 18-.1-.4s1-.1.2-.6c0 0 1-.1.8-.5q-.4-.3-.5-.2l.3-.2s.8.4.6.1l-.2-.3.7.4V16l.4.2V16l.4.3v-.2l.4.2V16s.5.1.5-.1c0 0 .4 0 .2.2l-.4.2-.6.4-.3.1H49l-.3.3h-.1l-.2.2-.2-.2-.3.3-.2-.1-.3.4-.2-.1-.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3719",
    d: "M46.2 17.5v.2h.2s1.4-.3.2-.7h.3c.2 0 1-.3.6-.5s-.7 0-.4-.3 0-.3 0-.3l-.8.5q-.4.2-.1.3t.5-.2c0 .1-.6.4-.5.6q0 .3.2.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.7 16.8q.4 0 .5-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b3c20",
    d: "m48.9 15.4.8.1.5.3s0 .3-.4.1v.2l-.3-.1-.1.1-.4-.2v.1l-.5-.1v.2s-.4-.4-.8-.3l.3.4s-.8 0-.7-.5 0-.3.5-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3719",
    d: "M45 16.6v.1l.5-.2v.1l-.4.4.9-.4c.3-.4 0-.2.5-.4s1-.8.6-.7l-.8.5q-.3.3-.4 0l.6-.2.3-.4s-.2-.3.4-.6c.5-.3 2-1.2 2.2-1.6l-1 .6-1.2.7q-.2 0-.2.2l-.9.8-.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3719",
    d: "M47.2 15.4h-.3l.2-.5 1-.4q.2 0-.8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aa5323",
    d: "M47.5 15.2s1.4.1 2.2-.8c0 0-1 .1-1.5.4l1-.6q1.3-.5 1.3-.8l-1.5.3h-.2l-.9.7.5-.2s-.2.7-1 .9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3719",
    d: "m44.6 16-.1.2.5-.2c.3-.2 1-.8.5-.8 0 0-.5 0-.5.3s-.4.5-.4.5m-1.3-.2q.2 0 .2.4s1.2-1 .8-1.2-.5.2-.5.2h.2zm-.3-.3.2.2s.8-.6.6-.8q-.3-.3-.5 0c0 .3.3 0 .2.2zm2.7-.6q-.2.1 0 .2h.3l.5-.6.3-.3q.5-.1 1.7-1c.5-.5.3-.4.9-.7q1-.6 1-1l-.4.2-1 .6-.3.1-.3.4-2 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aa5323",
    d: "M44.5 15.3h.5c.3 0 1.5-1.2 1.8-1.4l1.6-1.2.3-.4.5-.2c.3-.2 1.7-1 1.6-1.5l-2.6 1.7-2 1.4-.8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aa5323",
    d: "M44 14.8s.5 0 .5.2l1-.8.4-.4 2.3-1.6 1-.7c.3-.2 1.6-.9 1.5-1.4l-1.2.8-.5.2-.8.7-1.2.9-1.6 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aa5323",
    d: "m42.9 14.7.2.1s.4-.3.8 0l1.5-1.2 1-.6 1.2-.9q.4-.5 1-.7c.2-.2.8-.7.7-1l-.9.7c-.3.3-.3 0-.6.3l-1.4 1-.5.4-.4.2q-.2 0-.5.3l-.7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aa5323",
    d: "M43.3 14v-.3q.3-.2.5-.6-.1-.1.4-.3 1.6-.6 3.1-1.8l.7-.5v.4l-2.6 1.7-.9.5-.7.4.5-.2.9-.5.6-.4 1.5-1 .4-.2q.1 0 0 .2l-1.5 1-.3.3-.6.3-.5.4-1.5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aa5323",
    d: "M47.9 11q0 .2.4 0l1-.8.3-.4s-1 .5-1.7 1.1m1.3 0 .5-.5 1-.7-.2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b3c20",
    d: "M42 13.6s-.5.2-.3.3q.2.2.4 0h.3q.2 0 .4-.3l.5-.4.3-.4zm-2.5 1.8h.7v-.2q.2 0 .5-.3l.2-.2.7-.7-.2-.3-.7.5q-1 .3-1.8 1.1-.7 1 .2 1.3 0-.2 1.4-.2c1 0 1.4.5 1.5.5 0 .1.3.4 0 .8l.3-.1v-.1q.2 0 .1-.1 0-.4-.2-.6 0-.2.1-.1.2.2.2-.1l-.2-.2H42l-.7-.5.3-.2h-.3a1 1 0 0 0-1 0q.2-.2-.2-.3t-.8.3l.3-.6.4-.1q.3-.2.1-.3l1.1-.5s-.4.5-.8.6l-.5.3q-.5.1-.3.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3719",
    d: "M38.4 17.7s.2-1.1 1.3-1.2h1.5c.1.1.6.3.4.4l-.2.2q.2-.1 0-.3l-.3.1v.3h-.3q-.2.1 0 .1h.1q0 .2-.3.4l-.5.2q-.4 0-.9.4t-.8-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m39.7 17.7-.1-.3-.8-.1s.7 0 1-.2q.5-.3.2-.3t-.4.2v-.2l.4-.1.7-.1.3.2v.3h-.2l-.2.1q0 .3-.2.4.1-.2-.2-.5l-.5.1s.3.3 0 .5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3719",
    d: "M40.3 17q-.2 0 0-.2.3 0 .4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M49.7 15.1s-.3.1 0 .3l.6.4q.4 0 .4.3l-.1.5q-.1.2.2.1l.4-.2q.1 0 0 0-.2.2 0 .2h1.6q.4-.2.6-.5V16q.2-.1 0-.1l-.2.1q.2 0 .3-.2.1-.1 0-.2v-.1q0-.2-.2-.2l-.8.5-.6.1-.7.3q-.3.2-.2-.1 0 .1.4 0c.3-.3.2 0 .9-.3l.8-.4q.5-.2.3-.4t-.4 0q-.6.5-1.4.6s1.6-.7 1.4-.8l-.4-.2h-.4l-.4.2-.5.2-.7.3.8-.4.8-.4H52l-.5.1-.5.2-.6.2.3-.2h.2l.8-.3h-.8l-.4.2-.5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3719",
    d: "m40.6 16.8.1.2.2-.1q0-.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b3c20",
    d: "M40.2 18.8h.5s0-.5.1-.4h.2v-.3h.3q-.2-.1 0-.5l.4.2v-.2h.2c.1.1.2-.6 0-.7l-.5.2q-.4 0-.4.4l-.5.4q-.5.3-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M50.6 14.8h.2l.8-.3h-.8l-.4.2-.5.3-.2.1s-.3.1 0 .3l.6.4q.4 0 .4.3l-.1.5q-.1.2.2.1l.4-.2q.1 0 0 0-.2.2 0 .2h1.6q.4-.2.6-.5V16q.2-.1 0-.1l-.2.1q.2 0 .3-.2.1-.1 0-.2h-.2l-.6.2-.5.2c-.3 0-.7.4-.8.1h-.2q-.3.2-.2 0h-.1q0-.2.2-.2l.4-.2q-.3-.1-.4.1h-.4q.1-.3-.4-.4-.4 0-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m51.6 16.4 1-.3c.5-.1.1 0 0 0zm.1.1s.6-.2.7-.1zm1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m37.5 21.3.2-.7c.3-.3 1.5-1.6 1.7-2l.2.4.4-.5v.4l.8-.1-.1.3h1s-1 .5-.7.5h.5q0 .2-.7.3l.7.2q-.2-.1-1 .4v-.2l-.2.3q-.4.1-.6.4-.1.2-.5.3l-.1-.2-.5.1h-.8l.2-.1q.5 0 .7-.3l-.2-.5.1-.2-.1.3-.4.5q-.3 0-.4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38 21h.3l.1-.2v-.3l.2.1s.2.5-.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M37.7 20.7q.2.3.4.2l-.3.3q-.1-.2-.3-.2zm1.6-1.8.1-.2.2.3.4-.5v.4l.8-.1-.1.3h1s-1 .5-.7.5h.5q0 .2-.7.3l.7.2h-1.1q.1-.2.7-.3h-.3s-.4-.3-.1-.6l-.4.1.2-.3s-.5 0-.6.3V19l-.4.3zm-.9 2.1h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m39.2 19.7.3.3.2-.2.2.2.2-.2.3.1v-.3h.3q-.2 0 .4-.4-.2 0-.5.3h-.3v.3H40l-.2-.2-.3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc221",
    d: "m38 22.3.3-.1q.5-.3.8-.8 0-.4-.4-.2v.3l-.3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc221",
    d: "M38 22.4s-.4-.2 0-.4l.5-.4q0-.3 0 0c-.2 0-.8.2-.9 0h.5q.6-.2.4-.3h-1v.2l-.2.4q-.2.1 0 .4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M37.8 21.4v.1h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38 22.3q-.2 0 0-.3.4 0 .5-.3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAs);
export default __webpack_public_path__ + "static/media/as.d85f3f2eccbb2595f2de5ee2602cc740.svg";
export { ForwardRef as ReactComponent };